module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/caixa-logo-6cc689fb7952e706046c33bd67212504.svg";